module.exports = __webpack_public_path__ + "static/Snspic-bf2151888101619004c4519fa7c45d5b.png";